import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import DlUnitEditForm from './DlUnitEditForm';
import './DlUnitEdit.scss';
import { Nav } from 'react-bootstrap';
import { getUnit, newUnitInit } from "./../../actions";
import DlUnitSingleNav from './DlUnitSingleNav';


const mapStateToProps = (state) => ({
  itemId: state.dlUnit.dlUnitId, 
  item: state.dlUnit.dlUnit
});
const mapDispatchToProps = (dispatch) => ({
  getUnit: (id) => dispatch(getUnit(id)),
  newUnitInit: () => dispatch(newUnitInit())
});

const DlUnitEdit = ({ match, getUnit, newUnitInit, item }) => {
  const itemId = ( 'itemId' in match.params ? match.params.itemId : '' );
  useEffect(function() {
    if (itemId!=='') {
      getUnit(itemId);
    } else {
      newUnitInit();
    }  
  }, [itemId]);

  const [editType, setEditType] = useState('full');


  return (
    <div>
      <DlUnitSingleNav item={ item } />
      <Nav activeKey="/home" onSelect={selectedKey => setEditType(selectedKey)}>
        <Nav.Item>
          <Nav.Link eventKey="full" style={{ color: ( editType=='full' ? 'black' : 'grey' ) }}>ALL</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="hm" style={{ color: ( editType=='hm' ? 'black' : 'grey' ) }}>HM</Nav.Link>
        </Nav.Item>
      </Nav>
      <DlUnitEditForm editType={editType} />      
    </div>
  );

}

export default connect(mapStateToProps, mapDispatchToProps)(DlUnitEdit);
